import { render } from "./StampcodeNew.vue?vue&type=template&id=d0717c86&scoped=true"
import script from "./StampcodeNew.vue?vue&type=script&lang=js"
export * from "./StampcodeNew.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-d0717c86"

export default script